import React, { useState } from 'react'
import { tokenImages } from "../../constants/tokenImages";
import Environment from '../../utils/Environment';
import { useWeb3React } from '@web3-react/core';
import { useNavigate } from 'react-router-dom';
import { Modal, OverlayTrigger } from 'react-bootstrap';
import TaskTimer from './TaskTimer';
import TaskTimerDispute from './TaskTimerDispute';
import { updateTaskStatus } from "../../services/statusCompleted";
import useClaimReward from '../../hooks/similarTaskDetail/useClaimReward';
import useTooltips from '../../hooks/similarTaskDetail/useTooltips';
import { Link } from 'react-router-dom';
import BalanceOf from '../../hooks/read/balanceOf';
import { toast } from 'react-toastify';
import CustomToast from '../../components/CustomToast';
import { intitial_production_eth_id } from '../../constants/id';


function TaskCard({ taskData, curruntStatus, id, uniqueStatus, uniqueCode, fetchTaskData, setTaskIds, handleShow, handleShow2, userId, errorMsg, isWinner, createDispute, setLoader }) {

    const { account } = useWeb3React();
    const { getTooltip } = useTooltips();
    const [show6Claim, setShow6Claim] = useState(false);
    const handleClose6Claim = () => setShow6Claim(false);
    const handleShow6Claim = () => setShow6Claim(true);
    const [show4Claim, setShow4Claim] = useState(false);
    const handleClose4Claim = () => setShow4Claim(false);
    const handleShow4Claim = () => setShow4Claim(true);
    const [disputeConfirmation, setDisputeConfirmation] = useState(false);
    const close_Dispute_Confirmation_Modal = () => setDisputeConfirmation(false);
    const show_Dispute_Confirmation_Modal = () => setDisputeConfirmation(true);
    const navigate = useNavigate();
    function editTask() {
        navigate(`/createtask?edit=${id}`)
    }
    const {
        claimToken,
        claimToken1,
        handleClaim,
    } = useClaimReward(taskData, setLoader, fetchTaskData,
        updateTaskStatus, handleClose4Claim, handleClose6Claim,
        handleShow4Claim, handleShow6Claim);

    const { BalanceOfHook } = BalanceOf();

    const fetchBalanceHandle = async () => {
        setLoader(true);
        const res = await BalanceOfHook(Environment?.USDT);

        console.log(res, "fetchBalanceHandle...");
        let usdtBalance = (res / Math.pow(10, 6)).toString()  || 0;
        console.log(usdtBalance, "fetchBalanceHandle...");
        let requiredAmount = taskData?.disputeType === 'mini' ?  2 : 4;
        if (parseFloat(usdtBalance) >= parseInt(requiredAmount)) { // dispute amount is 400 USDT
          await createDispute(close_Dispute_Confirmation_Modal);
            setLoader(false);
        } else {
            setLoader(false);
            // toast?.error("You don't have enough funds in your wallet. To open a dispute, you need $400.");
            CustomToast.show('error', 'Error!', `You don't have enough funds in your wallet. To open a dispute, you need $${requiredAmount}.`)

        }
    }



    return (
        <>
            <div className="innerdetailsright">
                <div className="mainupperboxtop">
                    <div className="innerparentupperboxxxxxx">
                        <div className="left">
                            <p>Reward</p>
                            <h6>
                                {" "}
                                <img
                                    src={
                                        tokenImages[taskData?.currencySymbol] ||
                                        "/assets/edituploadimg.png"
                                    }
                                    alt="innerrewardimg"
                                    className="innerrewardimg adslfalsf"
                                />
                                {
                                    parseFloat(taskData?.reward) > 1000
                                        ? parseFloat(taskData?.reward).toLocaleString() // Format with commas if > 1000
                                        : Number(taskData?.reward) % 1 === 0
                                            ? parseFloat(taskData?.reward).toFixed(0) // No decimal places if it's an integer
                                            : parseFloat(taskData?.reward).toFixed(4) // Show 4 decimal places if it's a decimal
                                }{" "}
                                {taskData?.currencySymbol}
                            </h6>
                        </div>
                        <div className="left">
                            <p>Creator</p>
                            <h6>
                                {taskData?.user?.imageUrl ? (
                                    <img
                                        src={
                                            taskData?.user?.imageUrl.startsWith("http")
                                                ? taskData.user.imageUrl
                                                : `https://${taskData.user.imageUrl}`
                                        }
                                        alt="img"
                                        style={{ width: "24px" }}
                                        className="creatorimg"
                                    />
                                ) : null}
                                {taskData?.user?.name ||
                                    taskData?.user?.walletAddress?.slice(0, 5) +
                                    "..." +
                                    taskData?.user?.walletAddress?.slice(-5)}
                            </h6>
                        </div>
                    </div>
                    <div className="innerparentupperboxxxxxx">
                        <div className="left">
                            <p>Participants</p>
                            <div className="partcipantmainhead">
                                {taskData?.participants?.slice(0, 4).map((e, i) => {
                                    let classn;
                                    if (i == 0) {
                                        classn = "one";
                                    } else if (i == 1) {
                                        classn = "two";
                                    } else if (i == 2) {
                                        classn = "three";
                                    } else {
                                        classn = "four";
                                    }

                                    return (
                                        <div className={`participantmain ${classn}`}>
                                            <img
                                                src={
                                                    e?.user?.imageUrl
                                                        ? e.user.imageUrl.startsWith("http")
                                                            ? e.user.imageUrl
                                                            : `https://${e.user.imageUrl}`
                                                        : "/assets/edituploadimg.png"
                                                }
                                                alt="participantimg"
                                                className="participantimg adslfalsf"
                                            />{" "}
                                        </div>
                                    );
                                })}

                                {taskData?.participantCount > 4 && (
                                    <div className="participantmain five">
                                        <p className="numberimages">
                                            {parseInt(taskData?.participantCount) - 4}
                                        </p>
                                    </div>
                                )}
                                {taskData?.participantCount === "0" && (
                                    <div className="participantmain ">
                                        <p className="numberimages">0</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="left">
                            <p>TX HASH</p>
                            <h6>
                                {taskData?.taskTransactionHash?.slice(0, 8)}...{" "}
                                <a
                                    target="_blank"
                                    href={`${taskData?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${taskData?.taskTransactionHash}`}
                                >
                                    {" "}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M9.25 2.375H13.625V6.75M13.625 9.71063V12.6875C13.625 12.9361 13.5262 13.1746 13.3504 13.3504C13.1746 13.5262 12.9361 13.625 12.6875 13.625H3.3125C3.06386 13.625 2.8254 13.5262 2.64959 13.3504C2.47377 13.1746 2.375 12.9361 2.375 12.6875V3.3125C2.375 3.06386 2.47377 2.8254 2.64959 2.64959C2.8254 2.47377 3.06386 2.375 3.3125 2.375H6.125M8.5625 7.4375L13.3437 2.65625"
                                            stroke="#627F97"
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>{" "}
                                </a>
                            </h6>
                        </div>
                    </div>
                </div>
                {/* <div className="maintimer">
                                    <p className="endpara">Ends in</p>
                                    {taskData?.participants[0]?.status === 'winner' ?
                                        <TaskTimer endTime={0} />
                                        :
                                        <TaskTimer endTime={taskData?.endTime} />


                                    }

                                </div> */}
                {((taskData?.user?.walletAddress?.toLowerCase() === account?.toLowerCase()) && (new Date(taskData?.endTime) > new Date()) && (parseInt(taskData?.participantCount) === 0)) &&
                    <button
                        onClick={editTask}
                        className="participatebtn"
                    >
                        Edit Task
                        <span style={{ marginLeft: '5px' }}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={getTooltip("editTask")}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                >
                                    <path
                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                        fill="#B4C2CD"
                                    />
                                </svg>
                            </OverlayTrigger>
                        </span>
                    </button>}
                <div
                    className={
                        curruntStatus === "live"
                            ? "maintimerboxxxxxxxxxx Statu"
                            : "maintimerboxxxxxxxxxx "
                    }
                >
                    <div className="timerparentdiv">
                        <div className="innerleft">
                            {curruntStatus === "live" &&
                                uniqueStatus !== "submitted" ? (
                                <div className="dotimage">
                                    <img
                                        src="\assets\Frame2222.png"
                                        alt="img"
                                        className="img-fluid innerdotimage"
                                    />
                                </div>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="11"
                                    viewBox="0 0 11 11"
                                    fill="none"
                                >
                                    <rect
                                        width="11"
                                        height="11"
                                        rx="5.5"
                                        fill="#3EDD1E"
                                    />
                                    <path
                                        d="M3 6.13331L4.59082 8L8 4"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            )}

                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
<rect width="11" height="11" rx="5.5" fill="#3EDD1E"/>
<path d="M3 6.13331L4.59082 8L8 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> */}
                            <p style={{ color: "#627F97" }}>
                                Live{" "}
                                <span>
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={getTooltip("taskActive")}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="13"
                                            viewBox="0 0 12 13"
                                            fill="none"
                                        >
                                            <path
                                                d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                fill="#B4C2CD"
                                            />
                                        </svg>
                                    </OverlayTrigger>
                                </span>
                            </p>
                        </div>
                        {curruntStatus === "live" && (
                            <div className="innerright">
                                <p className="endpara">Ends in</p>
                                {taskData?.participants[0]?.status === "winner" ? (
                                    <TaskTimer endTime={0} />
                                ) : (
                                    <TaskTimer
                                        endTime={taskData?.endTime}
                                        fetchTaskData={fetchTaskData}
                                    />
                                )}
                            </div>
                        )}
                    </div>

                    {/* {curruntStatus === 'live' && */}
                    {/* <> */}
                    {/* {taskData?.participants[0]?.status === "winner" ? (
                    ""
                  ) : ( */}
                    <>
                        {uniqueCode ? (
                            (uniqueStatus === "submitted" || uniqueStatus === "winner" || uniqueStatus === "ended") || taskData?.participation ? (
                                <div className="mainbutton">
                                    <button className="disable">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                        >
                                            <path
                                                d="M16.148 5.46054L7.14798 14.4605C7.09574 14.5128 7.0337 14.5543 6.96541 14.5826C6.89713 14.6109 6.82393 14.6255 6.75001 14.6255C6.67609 14.6255 6.60289 14.6109 6.5346 14.5826C6.46632 14.5543 6.40428 14.5128 6.35204 14.4605L2.41454 10.523C2.30899 10.4175 2.24969 10.2743 2.24969 10.1251C2.24969 9.9758 2.30899 9.83265 2.41454 9.7271C2.52009 9.62155 2.66324 9.56226 2.81251 9.56226C2.96177 9.56226 3.10493 9.62155 3.21048 9.7271L6.75001 13.2673L15.352 4.6646C15.4576 4.55905 15.6007 4.49976 15.75 4.49976C15.8993 4.49976 16.0424 4.55905 16.148 4.6646C16.2535 4.77015 16.3128 4.9133 16.3128 5.06257C16.3128 5.21184 16.2535 5.35499 16.148 5.46054Z"
                                                fill="#013159"
                                            />
                                        </svg>{" "}
                                        Task Submitted
                                    </button>
                                </div>
                            ) : new Date(taskData?.endTime) > new Date() ? (
                                <button
                                    onClick={() => {
                                        setTaskIds(taskData?.id);
                                        handleShow2();
                                    }}
                                    className="participatebtn"
                                >
                                    Submit task
                                </button>
                            ) : null
                        ) : null}
                    </>
                    {/* )} */}
                    {taskData?.participants[0]?.status === "winner" ? (
                        ""
                    ) : (
                        <>
                            {userId ==
                                taskData?.userId ? null : uniqueCode ? null : new Date(
                                    taskData?.endTime
                                ) < new Date() ? null : account ? (
                                    taskData?.user?.imageUrl && taskData?.user?.name ? (
                                        <button
                                            onClick={() => {
                                                setTaskIds(taskData?.id);
                                                handleShow();
                                            }}
                                            className="participatebtn"
                                        >
                                            Participate{" "}
                                        </button>
                                    ) : (
                                        <button
                                            className="participatebtn"
                                            onClick={() => {
                                                setTaskIds(taskData?.id);
                                                handleShow();
                                            }}
                                        >
                                            Participate
                                        </button>
                                    )
                                ) : (
                                    <button onClick={errorMsg} className="participatebtn">
                                        Participate
                                    </button>
                                )}
                        </>
                    )}
                    {/* <div className='mainbutton'>
                                        <button><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <path d="M16.148 5.46054L7.14798 14.4605C7.09574 14.5128 7.0337 14.5543 6.96541 14.5826C6.89713 14.6109 6.82393 14.6255 6.75001 14.6255C6.67609 14.6255 6.60289 14.6109 6.5346 14.5826C6.46632 14.5543 6.40428 14.5128 6.35204 14.4605L2.41454 10.523C2.30899 10.4175 2.24969 10.2743 2.24969 10.1251C2.24969 9.9758 2.30899 9.83265 2.41454 9.7271C2.52009 9.62155 2.66324 9.56226 2.81251 9.56226C2.96177 9.56226 3.10493 9.62155 3.21048 9.7271L6.75001 13.2673L15.352 4.6646C15.4576 4.55905 15.6007 4.49976 15.75 4.49976C15.8993 4.49976 16.0424 4.55905 16.148 4.6646C16.2535 4.77015 16.3128 4.9133 16.3128 5.06257C16.3128 5.21184 16.2535 5.35499 16.148 5.46054Z" fill="#013159" />
                                        </svg> Task Submitted</button>
                                    </div> */}
                    {uniqueCode ? (
                        <p className="uniquepara">
                            Unique Secret Code:{" "}
                            <span className="code">{uniqueCode}</span>
                        </p>
                    ) : null}
                    {/* </>} */}
                </div>
                {/* {(userId == taskData?.userId) ? null : uniqueCode ? null : <button onClick={() => { setTaskIds(taskData?.id); handleShow() }} className="participatebtn">
                                    Participate
                                </button>} */}

                {/* <button className='participatebtn' onClick={handleShow22}>Participate</button> */}
                {/* {uniqueCode ? <p className="uniquepara">
                                    Unique Secret Code: <span className="code">{uniqueCode}</span>
                                </p> : null}
                                <div className="text-center mt-4">
                                    <a target="_blank" href={`https://etherscan.io/tx/${taskData?.taskTransactionHash}`}>      <img src="/assets/latesttask/explorer.svg" alt="" srcset="" /></a>
                                </div> */}
                <div className="bottomboxessmainnnn">
                    <div
                        className={
                            curruntStatus === "underReview"
                                ? "innerboxessssmain active"
                                : "innerboxessssmain"
                        }
                    >
                        <div className="parent">
                            <div className="left">
                                {curruntStatus === "underReview" ? (
                                    <div className="dotimage">
                                        <img
                                            src="\assets\Frame2222.png"
                                            alt="img"
                                            className="img-fluid innerdotimage"
                                        />
                                    </div>
                                ) : new Date(taskData?.reviewTimePeriod) < new Date() ||
                                    curruntStatus === "completed" ||
                                    curruntStatus === "winnerSelected" ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                    >
                                        <rect
                                            width="11"
                                            height="11"
                                            rx="5.5"
                                            fill="#3EDD1E"
                                        />
                                        <path
                                            d="M3 6.13331L4.59082 8L8 4"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <div className="innerleft"></div>
                                )}
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
<rect width="11" height="11" rx="5.5" fill="#3EDD1E"/>
<path d="M3 6.13331L4.59082 8L8 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> */}
                                <div className="innerright">
                                    <p>
                                        Under Review{" "}
                                        <span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={
                                                    taskData?.user?.walletAddress?.toLowerCase() == account?.toLowerCase() ?
                                                        getTooltip("reviewSubmissionsCreator")
                                                        :
                                                        taskData?.hasParticipated ?
                                                            getTooltip("reviewSubmissionsParticipated")
                                                            :
                                                            taskData?.participants[0] ?
                                                                getTooltip("reviewSubmissionsWinner")
                                                                :
                                                                getTooltip("reviewSubmissions")
                                                }
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                        fill="#B4C2CD"
                                                    />
                                                </svg>
                                            </OverlayTrigger>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            {curruntStatus === "underReview" && (
                                <div className="right">
                                    <p className="endpara">Ends in</p>
                                    {/* {taskData?.participants[0]?.status === "winner" ? (
                            <TaskTimer endTime={0} />
                          ) : ( */}
                                    <TaskTimer
                                        endTime={taskData?.reviewTimePeriod}
                                        fetchTaskData={fetchTaskData}
                                    />
                                    {/* )} */}
                                </div>
                            )}
                        </div>
                        {/* {curruntStatus === 'underReview' &&   <button className='red'>
                                            Create a Dispute
                                        </button> } */}
                        {/* <button className='redsecond'>
                                        Dispute Created
                                        </button> */}
                    </div>
                    <div
                        className={
                            curruntStatus === "inDisputePeriod"
                                ? "innerboxessssmain active"
                                : "innerboxessssmain"
                        }
                    >
                        <div className="parent">
                            <div className="left">
                                {curruntStatus === "inDisputePeriod" ? (
                                    <div className="dotimage">
                                        <img
                                            src="\assets\Frame2222.png"
                                            alt="img"
                                            className="img-fluid innerdotimage"
                                        />
                                    </div>
                                ) : new Date(taskData?.coolDownPeriod) < new Date() ||
                                    curruntStatus === "winnerSelected" || curruntStatus === "completed" ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                    >
                                        <rect
                                            width="11"
                                            height="11"
                                            rx="5.5"
                                            fill="#3EDD1E"
                                        />
                                        <path
                                            d="M3 6.13331L4.59082 8L8 4"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <div className="innerleft"></div>
                                )}
                                <div className="innerright">
                                    <p>
                                        In Dispute Period{" "}
                                        {/* {
                                            console.log(taskData, "userrrrrrr creator")
                                        } */}
                                        <span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={
                                                    taskData?.participants?.some(p => p.status === "winner" && p.user.walletAddress?.toLowerCase() === account?.toLowerCase()) ?
                                                        getTooltip("winnerSelectedWinner")
                                                        :
                                                        taskData?.user?.walletAddress?.toLowerCase() === account?.toLowerCase() ?
                                                            getTooltip("winnerSelectedCreator")
                                                            :
                                                            taskData?.hasParticipated ?
                                                                getTooltip("winnerSelectedParticipated")
                                                                :
                                                                getTooltip("winnerSelected")
                                                }
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                        fill="#B4C2CD"
                                                    />
                                                </svg>
                                            </OverlayTrigger>
                                        </span>
                                    </p>
                                </div>

                            </div>

                            {curruntStatus === "inDisputePeriod" && (
                                <div className="right">
                                    <p className="endpara">Ends in</p>
                                    {/* {taskData?.participants?.[0]?.status === "winner" ? (
                            <TaskTimer endTime={0} />
                          ) : ( */}
                                    <TaskTimer
                                        endTime={taskData?.coolDownPeriod}
                                        fetchTaskData={fetchTaskData}
                                    />
                                    {/* )} */}
                                </div>
                            )}
                        </div>
                        {/* {console.log(curruntStatus === "inDisputePeriod", (taskData?.user?.walletAddress?.toLowerCase() !==
                                            account?.toLowerCase()), taskData?.hasProofSubmitted, !isWinner, 'taskDatataskDatataskDatataskData')
                                        } */}
                        {(curruntStatus === "inDisputePeriod" && (taskData?.user?.walletAddress?.toLowerCase() !==
                            account?.toLowerCase()) && taskData?.hasProofSubmitted && !isWinner) ? (taskData?.hasDisputed ?
                                null
                                : <button onClick={show_Dispute_Confirmation_Modal} className="participatebtn redbtnforstyle ">
                                    Create a Dispute
                                </button>
                        ) : null}

                        {/* <button onClick={show_Dispute_Confirmation_Modal} className="participatebtn redbtnforstyle ">
                                    Create a Dispute
                                </button> */}

                        {/* {taskData?.hasDisputed || curruntStatus == "inDisputePeriod" || curruntStatus === "winnerSelected" || curruntStatus === "winnerSelected" && */}
                        {/* {console.log(curruntStatus,new Date() , taskData?.reviewTimePeriod , 'new Date() > taskData?.reviewTimePeriod ' )
                        } */}
                        {
                            (taskData?.hasCreator == true || taskData?.participation) && (new Date() > new Date(taskData?.reviewTimePeriod) && curruntStatus !== "completed") &&
                            <div className="disputedetail-box">
                                <div className="inner-parent">
                                    <div className="left-inner">
                                        <div className="text-detail">
                                            <h6>Dispute Created</h6>
                                            <p>Your initial proof of work has already been added to the case. You can now submit additional evidence to support your argument.</p>
                                        </div>
                                    </div>
                                    <div className="right-inner">
                                        <p>Time Remaining</p>
                                        {/* <TaskTimerDispute
                                            endTime={taskData?.coolDownPeriod}
                                            fetchTaskData={fetchTaskData}
                                        /> */}
                                        <h6>22H : 29M: 53S</h6>
                                    </div>
                                </div>
                                <Link to="/disputedetail" state={{ taskData: taskData, status: curruntStatus }}>
                                    <button className='btn-disputedetail'>Dispute Details</button>
                                </Link>
                            </div>
                            // <button disabled className="participatebtn disable">
                            //     Dispute Created
                            // </button>
                        }
                        {/* <Link to="/disputedetail" state={{ taskData: taskData, status: curruntStatus }}>
                            <button className='btn-disputedetail'>Dispute Details</button>
                        </Link> */}
                        {/* {(taskData?.hasCreator && curruntStatus === "inDisputePeriod") &&
                            <div className="disputedetail-box">
                                <div className="inner-parent">
                                    <div className="left-inner">
                                        <div className="text-detail">
                                            <h6>Dispute Created</h6>
                                            <p>Your initial proof of work has already been added to the case. You can now submit additional evidence to support your argument.</p>
                                        </div>
                                    </div>

                                </div>
                                {

                                }
                                <Link to="/disputedetail" state={{ taskData: taskData, status: curruntStatus }}>
                                    <button className='btn-disputedetail'>Dispute Details</button>
                                </Link>
                            </div>
                        } */}
                        {/* <Link to="/disputedetail" state={{ taskData: taskData, status: curruntStatus }}>
                            <button className='btn-disputedetail'>Dispute Details</button>
                        </Link> */}
                        {/* // <button disabled className="participatebtn disable">
                            //     Dispute Created
                            // </button>
                        } */}
                        {/* <Link to="/disputedetail" state={{ taskData: taskData, status: curruntStatus }}>
                            <button className='btn-disputedetail'>Dispute Details</button>
                        </Link> */}
                        {/* <div className="disputedetail-box">
                            <div className="inner-parent">
                                <div className="left-inner">
                                    <div className="text-detail">
                                        <h6>Dispute Created</h6>
                                        <p>Your initial proof of work has already been added to the case. You can now submit additional evidence to support your argument.</p>
                                    </div>
                                </div>
                                <div className="right-inner">
                                    <p>Time Remaining</p>
                                    <h6>22H : 29M: 53S</h6>
                                </div>
                            </div>
                            <Link to="/disputedetail">
                                <button className='btn-disputedetail'>Dispute Details</button>
                            </Link>
                        </div> */}
                    </div>
                    <div
                        className={
                            curruntStatus === "inVotingPeriod"
                                ? "innerboxessssmain active"
                                : "innerboxessssmain"
                        }
                    >
                        <div className="parent">
                            <div className="left">
                                {curruntStatus === "inVotingPeriod" ? (
                                    <div className="dotimage">
                                        <img
                                            src="\assets\Frame2222.png"
                                            alt="img"
                                            className="img-fluid innerdotimage"
                                        />
                                    </div>
                                ) : new Date(taskData?.votingEndPeriod) < new Date() ||
                                    curruntStatus === "completed" ||
                                    curruntStatus === "WinnerNotSelected" ||
                                    curruntStatus === "winnerSelected" ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                    >
                                        <rect
                                            width="11"
                                            height="11"
                                            rx="5.5"
                                            fill="#3EDD1E"
                                        />
                                        <path
                                            d="M3 6.13331L4.59082 8L8 4"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <div className="innerleft"></div>
                                )}
                                <div className="innerright">
                                    <p>
                                        In Voting Period{" "}
                                        <span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={getTooltip("disputeOpen")}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                        fill="#B4C2CD"
                                                    />
                                                </svg>
                                            </OverlayTrigger>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="right"></div>
                            {curruntStatus === "inVotingPeriod" && (
                                <div className="right">
                                    <p className="endpara">Ends in</p>
                                    {/* {taskData?.participants[0]?.status === "winner" ? ( */}
                                    {/* <TaskTimer endTime={0} />
                          ) : ( */}
                                    <TaskTimer
                                        endTime={taskData?.votingEndPeriod}
                                        fetchTaskData={fetchTaskData}
                                    />
                                    {/* )} */}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="innerboxessssmain ">
                        <div className="parent">
                            <div className="left">
                                {curruntStatus === "winnerSelected" ||
                                    curruntStatus === "completed" ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                    >
                                        <rect
                                            width="11"
                                            height="11"
                                            rx="5.5"
                                            fill="#3EDD1E"
                                        />
                                        <path
                                            d="M3 6.13331L4.59082 8L8 4"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <div className="innerleft"></div>
                                )}
                                <div className="innerright">
                                    <p>
                                        Winner Selected{" "}<span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={getTooltip("winnerSelectedShort")}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                        fill="#B4C2CD"
                                                    />
                                                </svg>
                                            </OverlayTrigger>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            {(curruntStatus === "winnerSelected" || curruntStatus === "completed") && taskData?.participants?.[0]?.status === "winner" ? (
                                <div className="d-flex align-items-center">
                                    <p className="pe-2 winner-text">Winner </p>
                                    {taskData.participants[0]?.user.imageUrl && (
                                        <img
                                            className="imgSize mx-2"
                                            src={taskData.participants[0]?.user.imageUrl}
                                            alt=""
                                            srcset=""
                                        />
                                    )}
                                    <div className="right winner-address">
                                        {" "}
                                        {taskData.participants?.[0].user.name
                                            ? taskData.participants?.[0].user.name
                                            : taskData.participants?.[0].user.walletAddress?.slice(
                                                0,
                                                8
                                            ) + "..."}
                                    </div>
                                </div>
                            ) : curruntStatus === "winnerSelected" || curruntStatus === "completed" ? (
                                <p className="refundeed">
                                    Refunded back to the creator
                                </p>
                            ) : null}
                        </div>
                        {/* {console.log(taskData?.participants)} */}
                        {taskData?.participants?.[0]?.status === "winner" ? (
                            curruntStatus === "completed" ? (
                                taskData?.participants?.[0]?.user?.walletAddress?.toLowerCase() ===
                                    account?.toLowerCase() ? (
                                    <button className="participatebtn">
                                        <svg
                                            className="me-1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                        >
                                            <path
                                                d="M16.148 5.46054L7.14798 14.4605C7.09574 14.5128 7.0337 14.5543 6.96541 14.5826C6.89713 14.6109 6.82393 14.6255 6.75001 14.6255C6.67609 14.6255 6.60289 14.6109 6.5346 14.5826C6.46632 14.5543 6.40428 14.5128 6.35204 14.4605L2.41454 10.523C2.30899 10.4175 2.24969 10.2743 2.24969 10.1251C2.24969 9.9758 2.30899 9.83265 2.41454 9.7271C2.52009 9.62155 2.66324 9.56226 2.81251 9.56226C2.96177 9.56226 3.10493 9.62155 3.21048 9.7271L6.75001 13.2673L15.352 4.6646C15.4576 4.55905 15.6007 4.49976 15.75 4.49976C15.8993 4.49976 16.0424 4.55905 16.148 4.6646C16.2535 4.77015 16.3128 4.9133 16.3128 5.06257C16.3128 5.21184 16.2535 5.35499 16.148 5.46054Z"
                                                fill="#013159"
                                            />
                                        </svg>{" "}
                                        Reward Claimed
                                    </button>
                                ) : null
                            ) : ((taskData?.participants?.[0]?.user?.walletAddress?.toLowerCase() ===
                                account?.toLowerCase()) && curruntStatus === "winnerSelected") ? (
                                <button
                                    className="participatebtn"
                                    onClick={() => handleClaim(taskData)}
                                >
                                    Claim Reward
                                </button>
                            ) : null
                        ) : null}
                    </div>
                    <div
                        className={
                            curruntStatus === "completed"
                                ? "innerboxessssmain "
                                : "innerboxessssmain "
                        }
                    >
                        <div className="parent">
                            <div className="left">
                                {curruntStatus === "completed" ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                    >
                                        <rect
                                            width="11"
                                            height="11"
                                            rx="5.5"
                                            fill="#3EDD1E"
                                        />
                                        <path
                                            d="M3 6.13331L4.59082 8L8 4"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <div className="innerleft"></div>
                                )}
                                <div className="innerright">
                                    <p>
                                        Completed
                                        <span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={getTooltip("taskCompleted")}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                                                        fill="#B4C2CD"
                                                    />
                                                </svg>
                                            </OverlayTrigger>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="right"></div>
                        </div>
                    </div>

                    <div className="forlinemain"></div>
                </div>
            </div>
            <Modal
                show={show4Claim}
                onHide={handleClose4Claim}
                className="modal_mainr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Claim Reward</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="70"
                            height="70"
                            viewBox="0 0 70 70"
                            fill="none"
                        >
                            <rect
                                x="5"
                                y="5"
                                width="60"
                                height="60"
                                stroke="#013159"
                                stroke-width="2"
                            />
                            <rect x="34" y="18" width="2" height="28" fill="#013159" />
                            <rect x="34" y="49" width="2" height="3" fill="#013159" />
                        </svg>
                        <h1>
                            Are you sure you want to claim <br />
                            {taskData?.reward} {taskData?.currencySymbol} for this task?
                        </h1>
                        <p className="parssa">
                            The reward sum will be transferred to your connected wallet.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose4Claim}>
                            Cancel
                        </button>
                        <button
                            className="surebutton"
                            onClick={() => {
                                {
                                    claimToken();
                                }
                            }}
                        >
                            Yes, I’m Sure
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={show6Claim}
                onHide={handleClose6Claim}
                className="modal_mainr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Claim Reward</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="70"
                            height="70"
                            viewBox="0 0 70 70"
                            fill="none"
                        >
                            <rect
                                x="5"
                                y="5"
                                width="0"
                                height="60"
                                stroke="#013159"
                                stroke-width="2"
                            />
                            <rect x="34" y="18" width="2" height="28" fill="#013159" />
                            <rect x="34" y="49" width="2" height="3" fill="#013159" />
                        </svg>
                        <h1>
                            Are you sure you want to claim <br />
                            {taskData?.reward} {taskData?.currencySymbol} for this task?
                        </h1>
                        <p className="parssa">
                            The reward sum will be transferred to your connected wallet.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose6Claim}>
                            Cancel
                        </button>
                        <button
                            className="surebutton"
                            onClick={() => {
                                claimToken1();
                            }}
                        >
                            Yes, I’m Sure
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={disputeConfirmation}
                onHide={close_Dispute_Confirmation_Modal}
                className="modal_mainr"
                centered
            >
                <Modal.Body>
                    <div className="modal4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">
                            <rect x="5" y="5.5" width="60" height="60" stroke="#013159" stroke-width="2" />
                            <rect x="24" y="19" width="2" height="22" transform="rotate(-90 24 19)" fill="#013159" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35 19H37L37 12H35L35 19ZM35 58H37L37 53H44H46V51V36V34H44H26V17H24V34V36H26L44 36V51H37H35H24V53H35L35 58Z" fill="#013159" />
                        </svg>
                        <h1>
                            Dispute Fee Details
                        </h1>
                        <p className="parssa">
                            To open a dispute, a fixed fee of {taskData?.disputeType === 'mini' ? '$15' : '$400'} will be charged from your wallet. This will be used as a service fee for DOP Oracles to review dispute cases and vote on the outcome to determine the winner.

                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer" style={{ flexDirection: "column-reverse", gap: "10px" }}>
                        <button className="cancelbutton m-0" onClick={close_Dispute_Confirmation_Modal}>
                            Cancel
                        </button>
                        <button
                            className="surebutton m-0"
                            onClick={() => fetchBalanceHandle()}
                        >
                            Confirm & Open Dispute
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>

    )
}

export default TaskCard